// import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { ArrowLeft } from '@peacecover/icon';
import { useGetPaymentList } from '../../domains/payments/ui/hooks/useGetPaymentList';
import { useHandleHistoryBack } from '../../utils/useHandleHistoryBack';
// import BettieRefundRequestBottomSheet from '../../components/bottomSheet/bettie/BettieRefundRequestBottomSheet';
import RefundExchangeNotice from './components/RefundExchangeNotice';
import BettiePurchaseHistoryItem from './components/BettiePurchaseHistoryItem';
import EmptyCaseWithTicketImage from './components/EmptyCaseWithTicketImage';
import type { components } from '../../types/schema';

type ApiV1Payment = components['schemas']['ApiV1Payment'];

const BettiePurchaseHistoryPage = () => {
  const handleHistoryBack = useHandleHistoryBack();
  const navigate = useNavigate();
  const { data: payments, isLoading } = useGetPaymentList();
  
  // const [isRefundRequestOpen, setIsRefundRequestOpen] = useState(false);
  // const [selectedPaymentId, setSelectedPaymentId] = useState('');

  const handleRefundButton = (item: ApiV1Payment) => {
    if (!item) return;
    if (item.subscription) {
      navigate('/bettie/subscriptions');
    }
    // else {
    //   setSelectedPaymentId(item.paymentId);
    //   setIsRefundRequestOpen(true);
    // }
  };

  return (
    <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[calc(env(safe-area-inset-bottom)+32px)]">
      <div className="sticky top-0 grid grid-cols-3 items-center px-[16px] py-[10px] bg-background-light dark:bg-background-dark">
        <ArrowLeft
          size={24}
          className="text-text-main-lv1 justify-self-start"
          onClick={handleHistoryBack}
        />
        <p className="col-start-2 text-[17px] font-bold text-text-main-lv1 leading-[20px] text-center">
          {t('BettiePurchaseHistory.title')}
        </p>
      </div>
      <div className="flex flex-col items-center px-[24px] mt-[16px]">
        <div className="w-full">
          {isLoading ? (
            <div className="w-full flex flex-col gap-[10px]">
              <BettiePurchaseCardSkeleton />
            </div>
          ) : payments?.length === 0 ? (
            <EmptyCaseWithTicketImage title={t('BettiePurchaseHistory.emptyCaseTitle')} />
          ) : (
            <div className="w-full flex flex-col gap-[10px]">
              {payments?.map((item) => (
                <BettiePurchaseHistoryItem
                  key={item.paymentId}
                  item={item}
                  onClick={() => handleRefundButton(item)}
                />
              ))}
            </div>
          )}
        </div>
        <RefundExchangeNotice className="mt-[100px]" />
      </div>
      {/* {isRefundRequestOpen && (
        <BettieRefundRequestBottomSheet
          isOpen={isRefundRequestOpen}
          onClose={() => setIsRefundRequestOpen(false)}
          paymentId={selectedPaymentId}
        />
      )} */}
    </div>
  );
};

export default BettiePurchaseHistoryPage;

const BettiePurchaseCardSkeleton = () => {
  return (
    <>
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: skelton key
          key={index}
          className="w-full px-[20px] py-[16px] bg-background-elevated rounded-[20px] shadow-[0_0_3px_0_rgba(0,0,0,0.06),_0_0_12px_0_rgba(0,0,0,0.08)] animate-pulse"
        >
          <div className="w-full flex flex-col gap-[15px] items-start justify-between">
            <div className="h-[14px] w-[80px] rounded-full bg-gray-100 dark:bg-gray-800" />
            <div className="flex justify-between items-center w-full">
              <div className="flex flex-col items-start gap-[6px] min-w-0 flex-1">
                <div className="h-[18px] w-[140px] rounded-full bg-gray-100 dark:bg-gray-800" />
                <div className="h-[16px] w-[180px] rounded-full bg-gray-100 dark:bg-gray-800" />
              </div>
              <div className="h-[19px] w-[60px] rounded-full bg-gray-100 dark:bg-gray-800 flex-shrink-0" />
            </div>
            {/* <div className="h-[33px] w-full rounded-[12px] bg-gray-100 dark:bg-gray-800" /> */}
          </div>
        </div>
      ))}
    </>
  );
}